import * as Sentry from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './App';
import Env from './utils/env';

if (Env.getEnvName() === Env.EnvNames.PROD) {
  Sentry.init({
    environment: 'production',
    ...(import.meta.env.VITE_SPA_VERSION && {
      release: `rhc-accounts@${import.meta.env.VITE_SPA_VERSION}`,
    }),
    dsn: 'https://5e483766981f48f782af2f5cbd08791a@o59191.ingest.sentry.io/5775446',
  });
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
